import { debounce } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { withRouter } from "react-router-dom"
import { compose, withHandlers, withState } from "recompose"
import { Search as SemanticSearch } from "semantic-ui-react"
import styled from "styled-components"
import { OrganizationsApiService } from "../../api"

const OrganizationAutosuggest = ({ autoFocus, isLoading, onSearch, onSelect, suggestions }) => (
	<Search
		aria-label="Nazwa urzędu"
		autoFocus={autoFocus}
		fluid
		loading={isLoading}
		noResultsMessage="Brak wyników"
		onResultSelect={onSelect}
		onSearchChange={debounce(onSearch, 300)}
		placeholder="Nazwa urzędu"
		results={suggestions}
		selectFirstResult
	/>
)

OrganizationAutosuggest.propTypes = {
	autoFocus: PropTypes.bool,
	isLoading: PropTypes.bool,
	onSearch: PropTypes.func.isRequired,
	onSelect: PropTypes.func.isRequired,
	suggestions: PropTypes.array
}

OrganizationAutosuggest.defaultProps = {
	suggestions: []
}

const Search = styled(SemanticSearch)`
	& > .input {
		width: 100%;
	}
`

const enhance = compose(
	withRouter,
	withState("isLoading", "setLoading", false),
	withState("suggestions", "setSuggestions", []),
	withHandlers({
		onSearch: ({ setLoading, setSuggestions }) => async (event, { value }) => {
			setLoading(true)
			try {
				const organizations = await OrganizationsApiService.getOrganizations()
				const suggestions = organizations
					.filter(({ name }) => name.toLowerCase().includes(value.toLowerCase()))
					.map(({ id, name: title }) => ({
						id,
						key: id,
						title
					}))
				setSuggestions(suggestions)
			} finally {
				setLoading(false)
			}
		},
		onSelect: ({ history }) => async (event, { result }) => {
			const { id } = result
			history.push(`/jednostki/${id}`)
		}
	})
)

export default enhance(OrganizationAutosuggest)



// WEBPACK FOOTER //
// ./src/components/organization-autosuggest/OrganizationAutosuggest.js